var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('PatientDiseasesList',{attrs:{"return-object":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_c('v-card-text',[_c('pre',[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }